import React, { useContext, useEffect, useState } from 'react'
import { apiGet } from '../../utils/apiFetch'
import apiPath from '../../utils/apiPath'
import BlogTable from './BlogTable'
// import BlogEdit from './BlogEdit'
// import BlogAdd from './BlogAdd'
import Pagination from '../Pagination'
import { useTranslation } from 'react-i18next'
import AuthContext from 'context/AuthContext'
import { useNavigate, Link } from 'react-router-dom';

function Blogs() {
  const { t } = useTranslation()
  const navigate = useNavigate();
  const { user } = useContext(AuthContext)
  const manager = user?.permission?.find(e => e.manager === 'blog_manager') ?? {}
  const [showModal, setShowModal] = useState(false)
  const [editShowModal, setEditShowModal] = useState(false)
  const [viewShow, setViewShow] = useState(false)
  const [blog, setBlog] = useState([])
  const [page, setPage] = useState(1)
  const [pageSize] = useState(10)
  const [item, setItem] = useState('')
  const [paginationObj, setPaginationObj] = useState({
    page: 1,
    pageCount: 1,
    pageRangeDisplayed: 10
  })
  const [sort, setSort] = useState({
    sortKey: 'createdAt',
    sortType: 'desc'
  })

  const allBlogs = async (data) => {
    try {
      const payload = {
        page,
        pageSize: pageSize,
        sortKey: sort.sortKey,
        sortType: sort.sortType
      }

      const path = apiPath.ListBlog
      const result = await apiGet(path, payload)
      const response = result?.data?.results
      const resultStatus = result?.data?.success
      setBlog(response?.docs)
      setPaginationObj({
        ...paginationObj,
        page: resultStatus ? response.page : null,
        pageCount: resultStatus ? response.totalPages : null,
        perPageItem: resultStatus ? response?.docs.length : null,
        totalItems: resultStatus ? response.totalDocs : null
      })
    } catch (error) {
      console.log('error in get all users list==>>>>', error.message)
    }
  }
  const handlePageClick = (event) => {
    const newPage = event.selected + 1
    setPage(newPage)
  }
  const handelEdit = (item) => {
    navigate('/blogs/edit-blog')
    setItem(item)
    setEditShowModal(true)
  }

  const handleUserView = (item) => {
    setItem(item)
    setViewShow(true)
  }

  useEffect(() => {
    allBlogs()
  }, [page, sort])

  return (
    <div>
      <div className='bg-[#F9F9F9]'>
        <div className='px-3 py-4'>
          <div className='bg-white border border-[#E9EDF9] rounded-lg'>
            <form className='border-b border-b-[#E3E3E3] 2xl:flex gap-2 px-4 py-3'>
              <div className='2xl:ml-auto xl:ml-0 lg:pt-0 pt-2'>
                <div className='flex justify-end'>
                  {(manager?.add ||
                    user?.role==='admin') && (
                      <button
                        title={t('ADD_BLOG')}
                        type='button'
                        className='bg-LightBlue flex text-sm px-8 ml-3 py-2 rounded-lg items-center border border-transparent text-white hover:bg-DarkBlue whitespace-nowrap'
                        onClick={(() => { navigate('/blogs/add-blog') })}
                      >
                        + {t('ADD_BLOG')}
                      </button>
                    )}
                </div>
              </div>
            </form>
            <BlogTable
              blog={blog}
              handelEdit={handelEdit}
              allBlogs={allBlogs}
              handleUserView={handleUserView}
              page={page}
              setSort={setSort}
              sort={sort}
              manager={manager}
            />
            {paginationObj?.totalItems ? (<Pagination
              handlePageClick={handlePageClick}
              options={paginationObj}
              page={page}
            />) : null}
          </div>
        </div>
      </div>

      <>
        {/* <EditBlog
          item={item}
        /> */}
        {/* {
          showModal
            ? (
              <BlogAdd setShowModal={setShowModal} allBlogs={allBlogs} />)
            : null
        } */}
        {/* {
          editShowModal && (
            <BlogEdit
              setEditShowModal={setEditShowModal}
              allBlogs={allBlogs}
              item={item}
            />)
        } */}
      </>
    </div>
  )
}

export default Blogs
